import React, {Component} from 'react';
import Vas from '../Vas';
import Request from '../custom_controls/Request';

import {ExtendedButton} from "component-lib";

class Test extends Component {

    test(){
        Request.ajax('json',null,true,"/CheckMailAddresses?mailAddress=shgjujfghjgfd@mail.de","GET",null,null,null,null,null,false);
    }
    
    render()
    {
        return (
                <div >
                    <ExtendedButton Usable={true} Width={150} className={"loginButton"}  Text={ Vas.Resources.Menus["Login"] }  OnClick={ ()=>{ this.test() }}/>
                </div>
        )
    }
}
export default Test;